import { useState } from "react";
import { useUpdateEffect } from "react-use";
import Icon from "../common/Icon";
import SevicesDocModal from "./SevicesDocModal";
import PrivacyDocModal from "./PrivacyDocModal";

const AgreeForm = ({ afterSave }) => {
  const checkList = [
    {
      id: "overage",
      label: "만 14세 이상입니다.",
      key: "agree_overage",
      required: false,
    },
    {
      id: "service",
      label: "이용약관 동의",
      key: "agree_service",
      required: true,
      doc: true,
    },
    {
      id: "privacy",
      label: "개인정보 수집 및 이용에 대한 동의",
      key: "agree_privacy",
      required: true,
      doc: true,
    },
    {
      id: "ad",
      label: "광고 전송 및 권유에 관한 선택적 동의",
      key: "agree_ad",
      required: false,
    },
  ];
  const [data, setData] = useState({
    all: false,
    overage: false,
    service: false,
    privacy: false,
    ad: false,
  });
  const [isAvailable, setAvailable] = useState(false);
  const [isServicesOpen, setOpenServices] = useState(false);
  const [isPrivacyOpen, setOpenPrivacy] = useState(false);

  const handleChange = (e) => {
    const { checked, id: target } = e.target;
    if (target === "all") {
      setData({
        all: checked,
        overage: checked,
        service: checked,
        privacy: checked,
        ad: checked,
      });
    } else {
      setData({ ...data, [target]: checked });
    }
  };

  const handleModalOpen = (type) => (e) => {
    if (type === "service") {
      setOpenServices(true);
      setOpenPrivacy(false);
    } else {
      setOpenServices(false);
      setOpenPrivacy(true);
    }
  };

  const handleModalClose = () => {
    setOpenPrivacy(false);
    setOpenServices(false);
  };

  const handleNext = () => {
    if (isAvailable) afterSave(data);
  };

  useUpdateEffect(() => {
    if (!data.all && data.overage && data.service && data.privacy && data.ad) {
      setData({
        all: true,
        overage: true,
        service: true,
        privacy: true,
        ad: true,
      });
    } else if (
      data.all &&
      !(data.overage && data.service && data.privacy && data.ad)
    ) {
      setData({ ...data, all: false });
    }
    if (data.all || (data.service && data.privacy)) {
      setAvailable(true);
    } else {
      setAvailable(false);
    }
  }, [data]);
  return (
    <div className="card-body">
      <div className="form-control">
        <label className="label cursor-pointer justify-start gap-2">
          <input
            id="all"
            type="checkbox"
            checked={data.all}
            onChange={handleChange}
            className="checkbox checkbox-primary rounded-md"
          />
          <span className="label-text font-bold text-lg">모두 동의합니다.</span>
        </label>
      </div>
      <hr className="mx-[-2rem]" />
      {checkList.map(({ id, key, label, required, doc }) => (
        <div className="form-control pl-2" key={key}>
          <label className="flex justify-between items-center">
            <label className="label cursor-pointer justify-start gap-2">
              <input
                id={id}
                type="checkbox"
                checked={data[id]}
                onChange={handleChange}
                className="checkbox checkbox-primary checkbox-sm rounded-md"
              />
              <span className="label-text">{`${label}${
                required ? " (필수)" : ""
              }`}</span>
            </label>
            {doc && (
              <button onClick={handleModalOpen(id)}>
                <Icon
                  name="chevron-right"
                  size="sm"
                  width={4}
                  className="text-gray-300 flex-none"
                />
              </button>
            )}
          </label>
        </div>
      ))}
      <div className="form-control pt-4">
        <button
          className="btn btn-primary"
          disabled={!isAvailable}
          onClick={handleNext}
        >
          다음
        </button>
      </div>
      {isServicesOpen && (
        <SevicesDocModal isOpen={isServicesOpen} onClose={handleModalClose} />
      )}
      {isPrivacyOpen && (
        <PrivacyDocModal isOpen={isPrivacyOpen} onClose={handleModalClose} />
      )}
    </div>
  );
};

export default AgreeForm;
